/**
 * Is the reading's meaning sealed on the live surface?
 *
 * One seal: who is looking. A logged-out viewer is not the seeker the reading
 * was cast for. The chat asks them to "Reveal Myself (Login)", and the top
 * pane used to stay open to them (prod, 2026-09-17), so log-in seals every
 * surface, not just the one that talks.
 *
 * There is no payment seal any more (2026-10-29, Chris: "just let them click
 * through and see the summary without needing to reveal"). Every reading is
 * paid at its start (backend reader/service/reading_charge), so a signed-in
 * seeker's reading is shown as it is written; an old one delivered unpaid
 * before the change is simply shown, never charged. `paid` and `subscribed`
 * are accepted for old callers and ignored.
 */
// eslint-disable-next-line no-unused-vars
export function readingLocked({ loggedIn = false, subscribed = false, paid = false, giftToViewer = false, linkHolder = false } = {}) {
  // A care package opened by its recipient: it was given to her, whole,
  // before she has an account (the landing always showed all of it).
  if (giftToViewer) return false
  // A link someone was sent (Send a link, SP-L3): it opens the reading as it
  // is for whoever holds it. `linkHolder` is the SERVER's word (the load
  // answered access: 'invite' for a live token), never the mere presence of
  // ?inv= in the address bar.
  if (linkHolder) return false
  return !loggedIn
}

/**
 * The one line that stands in for Rate/Share (and Ask) for a signed-out viewer.
 * A link holder is a visitor to someone else's reading, so it asks them to sign
 * in to ask or share, not to "log in" to something they are already reading.
 */
export function loginCtaLabelFor({ rate = false, linkHolder = false } = {}) {
  if (linkHolder) return 'Sign in to ask or share'
  return rate ? 'Log in to rate & share' : 'Log in to share'
}
